// extracted by mini-css-extract-plugin
export default {"title":"Investors-module--title--XSK+L","advisors":"Investors-module--advisors--alCxE","header":"Investors-module--header--nKk9y","companies":"Investors-module--companies--9CzX3"};